import React, { Component } from 'react';
import CRCTransfer from './CRCTransfer';
import RMTransfer from './RMTransfer';
import { connect } from 'react-redux';
import { saveParams } from '../../../actions/noticeActions';
import ExecuteSider from '../../execute/ExecuteSider';
import UserSider from '../UserSider';


class CoFollowFunds extends Component {
    state = {
        cur: 'CRC',
        tabs:[
            { lable:'CRC交接', key: 'CRC' },
            { lable:'PM交接', key: 'PM' }
        ],
        noticeParams:{ ...this.props.noticeParams }
    }

    handleBtnClick = (cur) => {
        this.setState({ cur });
    }

    componentDidMount(){
        const { noticeParams:{ type = 'CRC' } } = this.props;
        this.handleBtnClick(type)
    }

    render() {
        const { cur, tabs } = this.state;
        const { match , src, noticeParams} = this.props;
        const { invId } = sessionStorage;
        return (
            <div className="content">
                    {src !== 'User' ?
                        <ExecuteSider selectKey='transfer' />
                        : <UserSider selectKey='userTransfer' openKeys={['sub1']}/>
                    }
                <div className="main">
                    <div className="main-content">
                        {
                            invId && 
                            <div className="tab_flex">
                                {tabs.map(item=> 
                                <a className = { cur == item.key ? 'curr' : '' } onClick={() => this.handleBtnClick(item.key)}>
                                    {item.lable}
                                </a>
                                )}
                            </div>
                        }
                        { cur === 'CRC' && <CRCTransfer invId={invId} match={match} src={src}  /> }
                        { cur === 'PM' && <RMTransfer invId={invId} match={match} src={src} /> }
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = function (store) {
    return {
        searchParams: store.executeState.searchParams,
        noticeParams: store.noticeState.params,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: (params) => dispatch(saveParams(params)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CoFollowFunds);


// WEBPACK FOOTER //
// ./src/components/user/transfer/index.js